import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ShipmentsService } from 'src/app/core/services/basicServices/shipments.service';



@Component({
  selector: 'app-shipments',
  templateUrl: './shipments.component.html',
  styleUrls: ['./shipments.component.scss']
})
export class ShipmentsComponent implements OnInit {
 
  selectedItems: any[] = [];
  displayedColumns: string[] = ['select','parcelID','address' , 'salesOrderNumber','trackNo', 'service', 'shipmentID', 'dimensions','status','actions'];
  dataSource = new MatTableDataSource<any>();
  pageInfo:any;
  total=0
  page=1
  @ViewChild('paginator',{static:true}) paginator: MatPaginator;
 
  tableModel = {search:'', startDate:null,endDate:null,page:1,size:10 };

  constructor(private shipmentService:ShipmentsService,
    public router: Router,public Alerts: MatSnackBar) {}

  ngOnInit() {
    // this.dataSource.paginator = this.paginator;
    this.dataTableConfig();
  }


  dataTableConfig() {
    this.getList();
    // this.dataSource.paginator = this.paginator;
  }

  getList(){
    if(this.tableModel.startDate && this.tableModel.endDate){
      if(Date.parse(this.tableModel.startDate) > Date.parse(this.tableModel.endDate)){
        this.Alerts.open('Start date should not be greater than End date','OK')
        return false;
      }
    }
    this.shipmentService.getAllShipments(this.tableModel).subscribe(res=>{
      if(res){
        debugger
        this.dataSource.data=res.data;
        this.pageInfo= res.pageInfo
        this.total=res.pageInfo.total;
        this.paginator.length = this.total;
        this.page=res.pageInfo.pages;
      }
      else{
        this.dataSource.data=[];
      }
    })
  }

  onPaginate(pageEvent: PageEvent) {
    // debugger
    this.tableModel.size = pageEvent.pageSize;
    this.tableModel.page = pageEvent.pageIndex + 1;
    this.getList();
    // console.log(this.dataSource.sort)
  }

  view(id){
    if (id) {
      this.router.navigate(["main/viewShipment/"], { queryParams: { id: id } });
    } 
  }

  reset(){
    this.tableModel.search='';
    this.tableModel.startDate=null;
    this.tableModel.endDate=null;
    this.getList();
  }

  toggleSelection(item: any): void {
    const index = this.selectedItems.indexOf(item);
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }
  }

  isSelected(item: any): boolean {
    return this.selectedItems.indexOf(item.lable) !== -1;
  }

  masterToggle(event: MatCheckboxChange): void {
    if (event.checked) {
      this.dataSource.data.forEach(item => {
        if (!(this.isSelected(item))) {
          this.selectedItems.push(item.lable);
        }
      });
    } else {
      this.selectedItems = [];
    }
  }

  print(){
    this.shipmentService.printDocument(this.selectedItems).subscribe(res=>{
      if(res){
        this.Alerts.open('Printed Successfully','OK');
      }
    })
  }
}
